"use strict";
/// <reference path="../../../../../Trillium.UI/TypeScript/Models/Website/PieChartGridComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_chartist_1 = __importDefault(require("react-chartist"));
var ChartsLegendsComponent_1 = __importDefault(require("../ChartsLegendsComponent/ChartsLegendsComponent"));
var PieChartComponent = /** @class */ (function (_super) {
    __extends(PieChartComponent, _super);
    function PieChartComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChartComponent.prototype.render = function () {
        var chartData = {
            labels: this.props.Items.map(function (a) { return a.Label; }),
            series: this.props.Items.map(function (a) { return a.Value; })
        };
        var legendsData = this.props.Items.map(function (a) { return a.Legend; });
        var chartResponsiveOptions = [
            ['screen and (max-width: 640px)', {
                    chartPadding: 30,
                    labelOffset: 80,
                }],
            ['screen and (min-width: 640px)', {
                    chartPadding: 30,
                    labelOffset: 100,
                    labelDirection: 'explode'
                }],
            ['screen and (min-width: 1024px)', {
                    labelOffset: 80,
                    chartPadding: 20
                }]
        ];
        return (react_1.default.createElement("div", { id: "pieChart_" + this.props.UniqueKey, className: "chartComponent pieChartComponent" },
            react_1.default.createElement(react_chartist_1.default, { data: chartData, responsiveOptions: chartResponsiveOptions, type: 'Pie' }),
            react_1.default.createElement(ChartsLegendsComponent_1.default, { items: legendsData })));
    };
    return PieChartComponent;
}(react_1.default.Component));
exports.default = PieChartComponent;
